// extracted by mini-css-extract-plugin
module.exports = {"header":"header--nlkOh","logo":"logo--1BJO0","headerMenu":"headerMenu--1GBBS"};